//#region src/core/i18n/locales/ro.ts
var ro_default = {
	buttons: {
		play: "Redare",
		pause: "Pauză",
		replay: "Reluare",
		mute: "Fără sunet",
		unmute: "Cu sunet"
	},
	seek: {
		forward: "Salt înainte {seconds} secunde",
		backward: "Salt înapoi {seconds} secunde"
	},
	fullscreen: {
		enter: "Ecran complet",
		exit: "Ieșire ecran complet"
	},
	captions: {
		enable: "Activează subtitrările",
		disable: "Dezactivează subtitrările"
	},
	pip: {
		enter: "Imagine în imagine",
		exit: "Închidere imagine în imagine"
	},
	live: {
		playing: "Redare în direct",
		seekToEdge: "Salt la direct",
		badge: "În direct"
	},
	cast: {
		start: "Pornire transmisie",
		stop: "Oprire transmisie",
		connecting: "Se conectează"
	},
	airplay: {
		start: "Pornește AirPlay",
		stop: "Oprește AirPlay"
	},
	slider: { seek: "Derulare" },
	time: {
		current: "Ora curentă",
		duration: "Durată",
		remaining: "Timp rămas",
		elapsedSuffix: "{duration} de timp scurs",
		durationSuffix: "{duration} durată",
		remainingSuffix: "Mai rămân {duration}",
		showElapsed: "Afișează timpul scurs, {duration}.",
		showDuration: "Afișează durata, {duration}.",
		showRemaining: "Afișează timpul rămas, {duration}.",
		toggleElapsed: "Comută între timpul scurs și timpul rămas.",
		toggleDuration: "Comută între durată și timpul rămas.",
		position: "{current} din {duration}",
		unknown: "Fișierul media nu s-a încărcat, durată necunoscută."
	},
	playback: { rate: "Rată de redare {rate}" },
	volume: {
		mutedValue: "{percent}, mut",
		muted: "Mut",
		label: "Volum",
		value: "Volum {value}"
	},
	status: {
		captionsOn: "Subtitrări activate",
		captionsOff: "Subtitrări dezactivate",
		paused: "Pauză",
		playing: "Se redă",
		fullscreen: "Ecran complet",
		pip: "Imagine în imagine",
		exitPip: "Închidere imagine în imagine",
		seekedTo: "S-a trecut la {time}"
	},
	container: { label: "Player media" },
	errors: {
		aborted: "Ați abandonat redarea media",
		network: "O eroare de rețea a provocat eșecul descărcării conținutului media în timpul procesului.",
		decode: "Redarea media a fost întreruptă din cauza conținutului corupt sau din cauza faptului că acest conținut media folosește funcții pe care browserul dvs. nu le acceptă.",
		source: "Conținutul media nu a putut fi încărcat, fie pentru că serverul sau rețeaua a eșuat, fie pentru că formatul nu este acceptat.",
		encrypted: "Conținutul media este criptat și nu avem cheile pentru decriptare.",
		unplayable: "Acest fișier media nu este acceptat de player.",
		title: "Ceva a mers greșit.",
		unexpected: "A apărut o eroare. Vă rugăm să încercați din nou."
	},
	common: {
		empty: "",
		ok: "Închidere"
	},
	menu: {
		settings: "Setări",
		quality: "Calitate",
		audio: "Sunet",
		default: "Implicit",
		speed: "Viteză",
		captions: "Subtitrări",
		playbackRate: "Rată de redare",
		back: "Înapoi",
		off: "Dezactivat",
		auto: "Automat",
		autoWithLabel: "Automat ({label})",
		subtitles: "Subtitrări"
	}
};
//#endregion
export { ro_default as default };

//# sourceMappingURL=ro.js.map